/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Odhlásit se`
};

const da_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Log ud`
};

const de_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Abmelden`
};

const en_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Logout`
};

const es_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrar sesión`
};

const fr_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Déconnexion`
};

const hu_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Kijelentkezés`
};

const it_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Disconnetti`
};

const nl_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Uitloggen`
};

const pl_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Wyloguj się`
};

const pt_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Sair`
};

const sv_logout = /** @type {(inputs: {}) => string} */ () => {
	return `Logga ut`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const logout = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.logout(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("logout", locale)
	if (locale === "cs") return cs_logout(inputs)
	if (locale === "da") return da_logout(inputs)
	if (locale === "de") return de_logout(inputs)
	if (locale === "en") return en_logout(inputs)
	if (locale === "es") return es_logout(inputs)
	if (locale === "fr") return fr_logout(inputs)
	if (locale === "hu") return hu_logout(inputs)
	if (locale === "it") return it_logout(inputs)
	if (locale === "nl") return nl_logout(inputs)
	if (locale === "pl") return pl_logout(inputs)
	if (locale === "pt") return pt_logout(inputs)
	return sv_logout(inputs)
};